/**
 * Renders a card-network logo (Visa, Mastercard, Amex, …) for a saved payment method, falling back to a
 * generic card mark for unknown brands. Logos are the Apache-2.0 set in `./assets/card-brands/` (see
 * ATTRIBUTION.md). The brand string comes from PCI Booking's `cardType`.
 */

import amex from './assets/card-brands/amex.svg';
import diners from './assets/card-brands/diners.svg';
import discover from './assets/card-brands/discover.svg';
import generic from './assets/card-brands/generic.svg';
import jcb from './assets/card-brands/jcb.svg';
import maestro from './assets/card-brands/maestro.svg';
import mastercard from './assets/card-brands/mastercard.svg';
import unionpay from './assets/card-brands/unionpay.svg';
import visa from './assets/card-brands/visa.svg';

import { resolveCardBrandKey } from '@elara/client-core/lib/card-brand-mapping';

const BRAND_SVGS: Record<string, string> = { visa, mastercard, amex, discover, diners, jcb, unionpay, maestro };

interface CardBrandIconProps {
  brand: string | undefined;
  className?: string;
}

export function CardBrandIcon({ brand, className = 'h-7 w-11' }: CardBrandIconProps) {
  const key = resolveCardBrandKey(brand);
  const src = (key && BRAND_SVGS[key]) || generic;
  return (
    <img
      src={src}
      alt={brand ? `${brand} card` : 'Card'}
      className={`${className} rounded-sm shrink-0 object-contain`}
    />
  );
}
